// utils/realtimeHealth.ts — status koneksi realtime global (1 file, 1 tugas).
// Ditulis oleh subscription/subscribe.ts (SUBSCRIBED/ERROR/CLOSED/event),
// dibaca indikator footer (checksLocal: RT) + pemicu re-check via event.
// Tanpa ini suara putus diam-diam tak pernah ketahuan penyebabnya.

export interface RealtimeHealth {
  subscribedChannels: number;
  lastOkAt: number;
  lastErrorAt: number;
  lastError: string | null;
  lastEventAt: number;
}

const state: RealtimeHealth = {
  subscribedChannels: 0,
  lastOkAt: 0,
  lastErrorAt: 0,
  lastError: null,
  lastEventAt: 0,
};

function emit() {
  try {
    window.dispatchEvent(new CustomEvent('realtime-health-changed'));
  } catch { /* abaikan */ }
}

/** Dipakai juga oleh audioPlayer saat AudioContext berubah (nama event sama). */
export const notifyHealthChanged = emit;

export function reportRealtimeOk() {
  state.subscribedChannels += 1;
  state.lastOkAt = Date.now();
  emit();
}

export function reportRealtimeError(msg: string) {
  state.lastErrorAt = Date.now();
  state.lastError = msg;
  emit();
}

export function reportRealtimeEvent() {
  state.lastEventAt = Date.now();
}

export function getRealtimeHealth(): RealtimeHealth {
  return { ...state };
}
